var app = angular.module("leonardo");

var TaskUnitReportDialog = function($scope, $state, FilterService, ReportService, FormErrorsService, $rootScope, $timeout) {
  $scope.data = {
    name: FilterService.getFilter('unit_search'),
    property_reports: FilterService.getFilter('property')
  };
  $scope.status = [];
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    angular.forEach($scope.data, function(value, key) {
      FilterService.setFilter(key, value);
    });
    ReportService.setQuickReport({filters: $scope.data});
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $timeout(function () {
      $state.go('reports.unit');
    }, 100);
    $scope.closeThisDialog();
  };
};

app.controller('TaskUnitReportDialog', ['$scope', '$state', 'FilterService', 'ReportService', 'FormErrorsService',
  '$rootScope', '$timeout', TaskUnitReportDialog]);
